import React from 'react';
import { SelectedMarker, TabContainer } from './styles';

const Tab = ({ isSelected = false, label = '', handleOnTabClick = () => {}, tabId = 1 }) => {
  return (
    <TabContainer isSelected={isSelected} onClick={handleOnTabClick} data-publi={`tab-${tabId}`}>
      {label}
      {isSelected && <SelectedMarker />}
    </TabContainer>
  );
};

export default Tab;
